import { Form } from '@style/common/form';
import { ButtonDarkTheme } from '@style/components/button';
import { DividerDarkTheme } from '@style/components/divider';
import { MenuDarkTheme } from '@style/components/menu';
import { RadioDarkTheme } from '@style/components/radio';
import { SelectDarkTheme } from '@style/components/select';
import { SidebarDarkTheme } from '@style/components/sidebar';
import { StepsDarkTheme } from '@style/components/steps';
import { SwitchDarkTheme } from '@style/components/switch';
import { TableDarkTheme } from '@style/components/table';
import { TabsDarkTheme } from '@style/components/tabs';
import { TitleDarkTheme } from '@style/components/title';
import { StyleConfigInterface } from '@style/style.interfaces';

export const darkThemeConfig: StyleConfigInterface = {
  components: {
    Button: ButtonDarkTheme,
    Divider: DividerDarkTheme,
    Form,
    Menu: MenuDarkTheme,
    Radio: RadioDarkTheme,
    Select: SelectDarkTheme,
    Sidebar: SidebarDarkTheme,
    Steps: StepsDarkTheme,
    Switch: SwitchDarkTheme,
    Table: TableDarkTheme,
    Tabs: TabsDarkTheme,
    Title: TitleDarkTheme,
  },
};
